export declare type Language = 'en' | 'ru' | 'kk' | 'pt' | 'nl' | 'es' | 'fr';
export const AvailableLanguages = ['en', 'ru', 'kk', 'pt', 'nl', 'es', 'fr'];
